module.exports = __webpack_public_path__ + "static/media/expedia-mobile.b65b14bb.svg";